import React, { useState } from 'react';
import './aluminiumwindow.css';

import {
  FaShower,
  FaShieldAlt,
  FaWater,
  FaTools,
  FaCompressArrowsAlt,
  FaLayerGroup
} from 'react-icons/fa';

function ShowerCubicle() {
  const [activeTab, setActiveTab] = useState('types');
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
     '/shower cubicle 5.jpeg',
    '/s cubicle 2.jpg',
    '/s cubicle.jpeg',
    '/s cu.jpg',
   
   
  ];

  const features = [
    {
      icon: <FaShower />,
      title: 'Modern Shower Cubicles',
      description: 'Elegant aluminium-framed shower cubicles for contemporary bathrooms'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Tempered Safety Glass',
      description: 'High-strength toughened glass for enhanced safety'
    },
    {
      icon: <FaWater />,
      title: 'Water Resistant',
      description: 'Excellent resistance to moisture, rust, and corrosion'
    },
    {
      icon: <FaCompressArrowsAlt />,
      title: 'Space Efficient',
      description: 'Designed to maximize space in compact and luxury bathrooms'
    },
    {
      icon: <FaLayerGroup />,
      title: 'Custom Finishes',
      description: 'Clear, frosted, tinted glass with premium aluminium finishes'
    },
    {
      icon: <FaTools />,
      title: 'Easy Installation',
      description: 'Precision fabrication ensures quick and clean installation'
    }
  ];

  const systemTypes = [
    { name: 'Sliding Shower Cubicle', image: '/sliding cubicle.jpg' },
    { name: 'Hinged Shower Cubicle', image: '/hinged.jpg' },
    { name: 'Frameless Shower Cubicle', image: '/frameless.webp' },
    { name: 'Corner Shower Cubicle', image: '/corner.jpg' }
  ];

  return (
    <div className="aluminium-window">

      {/* Hero Section */}
      <section className="aluminium-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Aluminium Shower Cubicles</h1>
            <p className="hero-subtitle">
              Stylish, durable, and water-resistant shower cubicle solutions
              crafted for modern bathrooms.
            </p>
          </div>

          <div className="hero-image">
            <img
              src={images[selectedImage]}
              alt="Shower Cubicle"
              className="hero-main-image"
            />
            <div className="image-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Shower ${index + 1}`}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Choose Our Shower Cubicles?</h2>
          <p>Designed for durability, comfort, and elegance</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="tabs-header">
          <button
            className={`tab-btn ${activeTab === 'types' ? 'active' : ''}`}
            onClick={() => setActiveTab('types')}
          >
            Cubicle Types
          </button>

          <button
            className={`tab-btn ${activeTab === 'benefits' ? 'active' : ''}`}
            onClick={() => setActiveTab('benefits')}
          >
            Benefits
          </button>
        </div>

        <div className="tabs-content">

          {activeTab === 'types' && (
            <div className="window-types-grid">
              {systemTypes.map((type, index) => (
                <div key={index} className="window-type-card">
                  <img src={type.image} alt={type.name} />
                  <h4>{type.name}</h4>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="benefits-content">
              <div className="benefit-card">
                <h3>Long Lasting</h3>
                <p>Corrosion-resistant aluminium ensures extended lifespan.</p>
              </div>
              <div className="benefit-card">
                <h3>Low Maintenance</h3>
                <p>Easy to clean glass and frames require minimal upkeep.</p>
              </div>
              <div className="benefit-card">
                <h3>Enhanced Safety</h3>
                <p>Toughened safety glass reduces risk of injury.</p>
              </div>
              <div className="benefit-card">
                <h3>Premium Look</h3>
                <p>Adds a clean and luxurious feel to any bathroom.</p>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Upgrade Your Bathroom Experience</h2>
          <p>Contact us for  customized shower cubicle solutions</p>
          <div className="cta-buttons">
            <a href="/get-a-quote">
              <button className="btn-outline">Contact Us</button>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h4>Is tempered glass safe?</h4>
            <p>Yes, tempered glass is highly durable and shatters safely if broken.</p>
          </div>
          <div className="faq-item">
            <h4>Can sizes be customized?</h4>
            <p>Yes, all shower cubicles are custom fabricated to your space.</p>
          </div>
          <div className="faq-item">
            <h4>Do you provide installation?</h4>
            <p>Yes, we offer professional installation services.</p>
          </div>
        </div>
      </section>

    </div>
  );
}

export default ShowerCubicle;
